/* eslint-disable no-unneeded-ternary */
import { Button, Grid, Typography } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { AdminTestContext } from '@orientaction/Context';
import OaLabel from '@orientaction/commons/OaLabel';
import StyledDropzone from '@orientaction/commons/StyledDropzone';
import ResponseSelect from '@orientaction/components/TestVisibilityPermissionSection/ResponseSelect';
import { isNumeric } from '@orientaction/utils';
import classNames from 'classnames';
import { useContext, useEffect, useState } from 'react';
import { getNextId } from '../../utils';
import style from './style';

const placeholder = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <span style={{ fontSize: 26, margin: 8 }}>+</span>
      <span>Importer une image</span>
    </div>
  );
};

const ResponseForm = () => {
  const [title, setTitle] = useState<any>('');
  const [image, setImage] = useState<string>('');
  const [variableValue, setValue] = useState<any>();
  const [variableValueString, setValueString] = useState<any>();
  const [order, setOrder] = useState<any>();
  const [variable, setVariable] = useState<any>();
  const [errors, setErrors] = useState({
    title: false,
    image: false,
    variableValue: false,
    order: false,
    variable: false,
  });

  const { test, updateTest } = useContext<any>(AdminTestContext);

  const classes = style();
  
  const responseType = test?.questionToCreate?.responseType || 'text';
  const isImageMode = responseType === 'image';

  const handleSubmit = (e: any) => {
    e.stopPropagation();
    e.preventDefault();
    
    // Validation for text mode
    if (!isImageMode && title.trim().length < 1) {
      setErrors({ ...errors, title: true });
      return;
    }
    
    // Validation for image mode
    if (isImageMode && !image) {
      setErrors({ ...errors, image: true });
      return;
    }

    if (!isInterval && !variable) {
      setErrors({ ...errors, variable: true });
      return;
    }

    if (!isNumeric(variableValue) || variableValueString === '') {
      setErrors({ ...errors, variableValue: true });
      return;
    }

    if (!order) {
      setErrors({ ...errors, order: true });
      return;
    }

    const responseData = {
      title: isImageMode ? '' : title, // Empty title for image mode
      image: isImageMode ? image : '', // Empty image for text mode
      variableValue,
      order,
      variable,
      isNew: test.responseToEdit ? false : true,
    };

    if (test.responseToEdit) {
      const objectToMove = {
        id: test.responseToEdit.id,
        title: isImageMode ? '' : title,
        image: isImageMode ? image : '',
        variableValue,
        order,
        variable,
        isNew: !!test.responseToEdit.isNew,
      };
      const currentIndex = test.questionToCreate.responses.findIndex(
        (obj: any) => obj.id === objectToMove.id
      );

      // Remove the object from its current position
      if (currentIndex !== -1) {
        test.questionToCreate.responses.splice(currentIndex, 1);
      }

      // Move the object to the desired position (e.g., first position)
      test.questionToCreate.responses.splice(order - 1, 0, objectToMove);
      const rearrangedArray = test.questionToCreate.responses.map((arr: any, index: number) => ({
        ...arr,
        order: index + 1,
      }));

      updateTest({
        questionToCreate: {
          ...test.questionToCreate,
          responses: rearrangedArray,
        },
        responseDrawerOpen: false,
        responseToEdit: undefined,
      });
    } else if (order >= test.questionToCreate.responses.length + 1) {
      const responseId = getNextId(test.questionToCreate.responses);
      const newArray = [
        ...test.questionToCreate.responses,
        { id: responseId, title: isImageMode ? '' : title, image: isImageMode ? image : '', variableValue, order, variable, isNew: true },
      ];
      // rearrange order
      const rearrangedArray = newArray.map((arr: any, index: number) => ({
        ...arr,
        order: index + 1,
      }));
      updateTest({
        questionToCreate: { ...test.questionToCreate, responses: rearrangedArray },
        responseDrawerOpen: false,
      });
    } else {
      const responseId = getNextId(test.questionToCreate.responses);
      const beforeInsert = test.questionToCreate.responses.slice(0, order - 1);
      const afterInsert = test.questionToCreate.responses.slice(order - 1);
      const newArray = [
        ...beforeInsert,
        { id: responseId, title: isImageMode ? '' : title, image: isImageMode ? image : '', variableValue, order, variable, isNew: true },
        ...afterInsert,
      ];
      // rearrange order
      const rearrangedArray = newArray.map((arr: any, index: number) => ({
        ...arr,
        order: index + 1,
      }));
      updateTest({
        questionToCreate: { ...test.questionToCreate, responses: rearrangedArray },
        responseDrawerOpen: false,
      });
    }
  };

  const handleTitleChange = (e: any) => {
    setTitle(e.target.value);
    if (errors.title) {
      setErrors({ ...errors, title: false });
    }
  };

  const handleValueChange = (e: any) => {
    if (parseInt(e.target.value, 10) >= 0 || e.target.value === '') {
      setValue(+e.target.value);
      setValueString(e.target.value);
      if (errors.variableValue) {
        setErrors({ ...errors, variableValue: false });
      }
    }
  };

  const handleOrderChange = (e: any) => {
    if (!test.responseToEdit) {
      if (+e.target.value > test.questionToCreate.responses.length) {
        const newOrder = test.questionToCreate.responses.length + 1;
        setOrder(newOrder);
      } else {
        setOrder(+e.target.value);
      }
    } else if (+e.target.value > test.questionToCreate.responses.length) {
      const newOrder = test.questionToCreate.responses.length;
      setOrder(newOrder);
    } else {
      setOrder(+e.target.value);
    }
    if (errors.order) {
      setErrors({ ...errors, order: false });
    }
  };

  const handleVariableChange = (data: any) => {
    setVariable(data);
  };

  const handleImageChange = (url: string) => {
    setImage(url);
    if (errors.image) {
      setErrors({ ...errors, image: false });
    }
  };

  const handleDeleteImage = () => {
    setImage('');
  };

  useEffect(() => {
    if (test.responseToEdit) {
      const div = document.createElement('div');
      div.innerHTML = test?.responseToEdit?.title;
      const text = div.textContent || div.innerText || '';
      setTitle(text);
      setValue(test?.responseToEdit?.variableValue);
      setOrder(test?.responseToEdit?.order);
      setValueString(test?.responseToEdit?.variableValue);
      setImage(test?.responseToEdit?.image || '');

      const variableAssociated = (test?.variables || []).filter((v: any) => {
        const responseVariables = test?.responseToEdit?.variable;
        const variablesArray = Array.isArray(responseVariables)
          ? responseVariables
          : responseVariables
          ? [responseVariables]
          : [];

        return variablesArray.some((rv: any) => rv?.id === v?.id);
      });

      setVariable(
        variableAssociated.map((c: any) => {
          return { ...c, value: c.id, label: c.name };
        })
      );
    } else {
      const newOrder = test.questionToCreate.responses.length + 1;
      setOrder(newOrder);
    }
  }, [test.questionToCreate.responses.length, test.responseToEdit, test?.variables]);

  const responseIndex = test.responseToEdit
    ? (test?.questionToCreate?.responses || []).findIndex(
        (r: any) => r.id === test.responseToEdit.id
      )
    : test.questionToCreate.responses.length;

  const { diagram } = test.test;

  const isInterval = diagram?.id === 4;

  return (
    <form className={classes.flexContainer} onSubmit={handleSubmit}>
      <Typography className={classes.responseFormTitle} component="h2">
        RÉPONSE N°{responseIndex + 1}
      </Typography>
      <div className={classNames(classes.marginTop, classes.fullWidth)}>
        {isImageMode ? (
          <>
            <OaLabel>Image de la réponse</OaLabel>
            <StyledDropzone
              fileUrl={image}
              handleFileUrlChange={handleImageChange}
              placeholder={placeholder}
              sectionTop={true}
              error={errors.image}
              pathPrefix="responseImages"
            />
            {image && (
              <div onClick={handleDeleteImage} className={classes.replaceTextContainer}>
                Remplacer
              </div>
            )}
          </>
        ) : (
          <>
            <OaLabel>Titre de la réponse</OaLabel>
            <TextField
              id="outlined-basic"
              variant="outlined"
              multiline={true}
              minRows={3}
              maxRows={5}
              className={classNames({ [classes.formInput]: true }, { [classes.error]: errors.title })}
              name="variableName"
              onChange={handleTitleChange}
              value={title}
              placeholder="Renseignez le titre de la réponse"
            />
          </>
        )}
      </div>
      {!isInterval && (
        <div className={classNames(classes.marginTop, classes.fullWidth)}>
          <OaLabel>Restitutions liées</OaLabel>
          {/*       <Select
          placeholder="Sélectionnez"
          options={test.variables}
          getOptionLabel={(option) => option.name}
          getOptionValue={(option) => option.id}
          value={variable}
          onChange={handleVariableChange}
          isMulti={true}
          className={classNames({
            [classes.formSelect]: true,
            [classes.inputError]: errors.variable,
          })}
        /> */}
          <ResponseSelect
            variableList={test.variables.map((c: any) => {
              return { ...c, value: c.id, label: c.name };
            })}
            variables={variable}
            updateVariable={handleVariableChange}
            error={errors.variable}
          />
        </div>
      )}
      <Grid container={true}>
        <Grid item={true} md={6} spacing={4}>
          <OaLabel>{isInterval ? 'Score' : 'Valeur'}</OaLabel>
          <TextField
            id="response-value"
            variant="outlined"
            className={classNames(classes.textField, errors.variableValue && classes.error)}
            name="responseValue"
            onChange={handleValueChange}
            value={variableValueString}
            placeholder="Indiquez la valeur"
            inputProps={{
              type: 'number',
              min: 0,
              step: 1,
            }}
          />
        </Grid>
        <Grid item={true} md={6}>
          <OaLabel>{`Ordre d'affichage`}</OaLabel>
          <TextField
            id="response-order"
            variant="outlined"
            className={classNames(classes.textField, errors.order && classes.error)}
            name="responseOrder"
            onChange={handleOrderChange}
            value={order}
            inputProps={{
              type: 'number',
              min: 0,
              step: 1,
            }}
          />
        </Grid>
      </Grid>
      <div className={classes.marginTop}>
        <Button id="response-submit" type="submit" className={classes.btnPrimary}>
                          <span className={classes.textHeader}>Valider</span>
        </Button>
      </div>
    </form>
  );
};

export default ResponseForm;
